// Navigation Bar SECTION
const navBar = {
  show: true,
};

// Main Body SECTION
const mainBody = {
  firstName: "Anastan",
  middleName: "",
  lastName: "Gnanapragasam",
  message: "Engineer who loves building things that scale.",
  icons: [
    {
      image: "fa-github",
      url: "https://github.com/anastang",
    },
    {
      image: "fa-linkedin",
      url: "https://www.linkedin.com/in/anastang/",
    },
  ],
};

// ABOUT SECTION
// For Resume either provide link to your resume or import from "editable-stuff" directory
//     i.e resume: require("../editable-stuff/resume.pdf"),
//         resume: "https://docs.google.com/document/d/13_PWdhThMr6roxb-UFiJj4YAFOj8e_bv3Vx9UHQdyBQ/edit?usp=sharing",

const about = {
  show: true,
  heading: "About Me",
  imageLink: require("../../src/assets/img/headshot.jpg"),
  message:
    "Hey, I'm Anastan, a Management Engineering grad from Waterloo who likes building things, from data pipelines to random side projects. Most of my co-ops have been in data engineering and AI. Outside of that, I'm probably watching soccer, finding a new film, or planning the next trip.",
  // resume: "https://docs.google.com/document/d/e/2PACX-1vS3H4djip2oc5zVUhn3RXhwIXQ_sD9mpCUsFeYTQCp0iVDSD-fNF2eqRJxsb5Vjm7AkC0uaH9EyYTvv/pub",
};

// PROJECTS SECTION
// Setting up project lenght will automatically fetch your that number of recently updated projects, or you can set this field 0 to show none.
//      i.e: reposLength: 0,
// If you want to display specfic projects, add the repository names,
//      i.e ["repository-1", "repo-2"]
// For a repo you don't own but contributed to, use the full "owner/repo" form,
//      i.e "someone-else/their-repo"
const repos = {
  show: true,
  heading: "Projects",
  gitHubUsername: "anastang", //i.e."johnDoe12Gh"
  reposLength: 0,
  specificRepos: ["mindflux", "private-data-rag-pipeline", "satellite-image-classification", "uwstudysync", "storm-tracker", "devcoin", "PlayByGPT", "achchala/StreetSmart"],
  // Order to feature on the homepage preview (View all on /work shows everything above).
  featured: ["achchala/StreetSmart", "uwstudysync", "mindflux", "private-data-rag-pipeline"],
};

// Leadership SECTION
const leadership = {
  show: false,
  heading: "Leadership",
  message:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Vitae auctor eu augue ut lectus arcu bibendum at varius. Libero justo laoreet sit amet cursus sit amet. Imperdiet dui accumsan sit amet nulla facilisi morbi. At auctor urna nunc id. Iaculis urna id volutpat lacus laoreet non curabitur gravida. Et magnis dis parturient montes nascetur ridiculus mus mauris. In nisl nisi scelerisque eu ultrices vitae auctor. Mattis nunc sed blandit libero volutpat sed cras ornare. Pulvinar neque laoreet suspendisse interdum consectetur libero.",
  images: [
    {
      img: require("../../src/assets/img/headshot.jpg"),
      label: "First slide label",
      paragraph: "Nulla vitae elit libero, a pharetra augue mollis interdum."
    },
    {
      img: require("../../src/assets/img/headshot.jpg"),
      label: "Second slide label",
      paragraph: "Nulla vitae elit libero, a pharetra augue mollis interdum."
    },
  ],
  imageSize: {
    width:"615",
    height:"450"
  }
};

// MY STACK SECTION
// FontAwesome 5 brand/solid icon classes — see https://fontawesome.com/v5/search
// `color` is used for the icon's hover state.
const stack = {
  show: true,
  heading: "My Stack",
  items: [
    { icon: "fab fa-python", label: "Python", color: "#3776AB" },
    { icon: "fas fa-database", label: "SQL", color: "#4479A1" },
    { icon: "fab fa-js", label: "JavaScript", color: "#F7DF1E" },
    { icon: "fab fa-react", label: "React", color: "#61DAFB" },
    { icon: "fab fa-node-js", label: "Node.js", color: "#339933" },
    { icon: "fas fa-wind", label: "Airflow", color: "#017CEE" },
    { icon: "fas fa-broadcast-tower", label: "Kafka", color: "#8B5CF6" },
    { icon: "fas fa-bolt", label: "PySpark", color: "#E25A1C" },
    { icon: "fas fa-cubes", label: "Databricks", color: "#FF3621" },
    { icon: "fas fa-brain", label: "PyTorch", color: "#EE4C2C" },
    { icon: "fas fa-link", label: "LangChain", color: "#00A67E" },
    { icon: "fas fa-chart-line", label: "Power BI", color: "#F2C811" },
    { icon: "fab fa-aws", label: "AWS", color: "#FF9900" },
    { icon: "fab fa-docker", label: "Docker", color: "#2496ED" },
  ],
};

// GET IN TOUCH SECTION
const getInTouch = {
  show: true,
  heading: "Let's Connect",
  message: "Always happy to chat —",
  email: "anastan.gp@gmail.com"
};

// EXPERIENCE SECTION
// Ordered most-recent first. Full list shown on the /work page.
const experiences = {
  show: true,
  heading: "Experience",
  data: [
    {
      role: "Data Engineer Intern",
      company: "Tesla",
      date: "Sep 2025 – Dec 2025",
      logo: require("../assets/logos/tesla.png"),
      blurb:
        "Worked with Tesla's service and factory-data teams, building streaming pipelines for real-time equipment monitoring and turning multi-day manual reports into same-day dashboards.",
    },
    {
      role: "Data Engineer Intern",
      company: "RideCo",
      date: "Jan 2025 – Apr 2025",
      logo: require("../assets/logos/rideco.png"),
      blurb:
        "Automated paratransit billing for a major transit authority, cutting a multi-day reconciliation process down to hours.",
    },
    {
      role: "Data Engineer Intern",
      company: "PINpoint Information Systems",
      date: "May 2024 – Aug 2024",
      logo: require("../assets/logos/pinpoint.png"),
      blurb:
        "Built real-time factory dashboards and a computer-vision inspection tool for manufacturing clients like Caterpillar.",
    },
    {
      role: "Software Engineer Intern",
      company: "Ontario Government — Ministry of Natural Resources and Forestry",
      date: "Sep 2023 – Dec 2023",
      logo: require("../assets/logos/ontario.png"),
      blurb:
        "Contributed to a platform modernization effort on a large internal government service.",
    },
    {
      role: "Data Engineer Intern",
      company: "Life Design Analysis",
      date: "Jan 2023 – Apr 2023",
      logo: require("../assets/logos/lifedesign.png"),
      blurb:
        "Kept a data warehouse running smoothly for a small analytics team, cutting downtime by 90% through better indexing and caching.",
    },
  ]
}

export { navBar, mainBody, about, repos, leadership, stack, getInTouch, experiences };
